import { makeStyles } from "@material-ui/styles";

const drawerWidth = 256;
export default makeStyles(theme => ({
  root: {
    display: "flex"
    // minHeight: "100vh"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
    // minHeight: "100vh"
    // padding: theme.spacing(4)
  }
}));
